/**
 * Comfort Bra size finder — maps EU band+cup to S–3XL and selects variant.
 */
class ComfortBraSizeFinder extends HTMLElement {
  #sizeMap = {
    '65A': 'S', '65B': 'S', '70A': 'S', '70B': 'S',
    '70C': 'M', '70D': 'M', '75A': 'M', '75B': 'M',
    '75C': 'L', '75D': 'L', '80A': 'L', '80B': 'L',
    '80C': 'XL', '80D': 'XL', '85A': 'XL', '85B': 'XL',
    '85C': '2XL', '85D': '2XL', '90A': '2XL', '90B': '2XL', '90C': '2XL',
    '90D': '3XL', '95A': '3XL', '95B': '3XL', '95C': '3XL', '95D': '3XL',
    '100A': '3XL', '100B': '3XL', '100C': '3XL', '100D': '3XL',
    '65C': 'S', '65D': 'S', '75E': 'L', '80E': 'XL', '85E': '2XL',
    '90E': '3XL', '95E': '3XL', '70E': 'M', '75F': 'XL', '80F': '2XL',
    '85F': '3XL', '90F': '3XL', '65E': 'M', '65F': 'M', '70F': 'L',
    '100E': '3XL', '100F': '3XL'
  };

  connectedCallback() {
    this.bandSelect = this.querySelector('[data-cb-band]');
    this.cupSelect = this.querySelector('[data-cb-cup]');
    this.sizeDisplay = this.querySelector('[data-cb-size-display]');
    this.sizePlaceholder = this.querySelector('[data-cb-size-placeholder]');
    this.resultSizeEl = this.querySelector('[data-cb-result-size]');
    this.sectionId = this.dataset.sectionId;
    this.sizeOption = this.dataset.sizeOption;
    this.sizes = (this.dataset.sizes || '').split(',').filter(Boolean);

    this.bandSelect?.addEventListener('change', () => this.#updateResult());
    this.cupSelect?.addEventListener('change', () => this.#updateResult());
  }

  #getRecommendedSize() {
    const band = this.bandSelect?.value;
    const cup = this.cupSelect?.value;
    if (!band || !cup) return null;
    return this.#sizeMap[`${band}${cup}`] || null;
  }

  #updateResult() {
    const size = this.#getRecommendedSize();

    if (!size || !this.sizes.includes(size)) {
      this.sizeDisplay?.classList.remove('has-value');
      this.sizePlaceholder?.removeAttribute('hidden');
      if (this.resultSizeEl) {
        this.resultSizeEl.textContent = '';
        this.resultSizeEl.setAttribute('hidden', '');
      }
      return;
    }

    if (this.resultSizeEl) {
      this.resultSizeEl.textContent = size;
      this.resultSizeEl.removeAttribute('hidden');
    }
    this.sizePlaceholder?.setAttribute('hidden', '');
    this.sizeDisplay?.classList.add('has-value');
    this.#applySize(size);
  }

  #applySize(size) {
    const picker = document.querySelector(`variant-picker[data-section-id="${this.sectionId}"]`);

    if (picker) {
      const input = picker.querySelector(
        `input[type="radio"][data-option-name="${CSS.escape(this.sizeOption)}"][value="${CSS.escape(size)}"]`
      );

      if (input && !input.disabled) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.closest('label')?.click();
        this.#highlightSize(input);
      }
    }

    const bundles = document.querySelector('comfort-bra-bundles');
    if (bundles?.getBundleState && bundles?.setItemSelection) {
      const state = bundles.getBundleState();
      state.selections.forEach((_, index) => {
        bundles.setItemSelection(index, null, size);
      });
    }
  }

  #highlightSize(input) {
    document.querySelectorAll('.cb-size-applied-flash').forEach((el) => {
      el.classList.remove('cb-size-applied-flash');
    });
    input.closest('.variant-option')?.classList.add('cb-size-applied-flash');
    input.closest('fieldset')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}

if (!customElements.get('comfort-bra-size-finder')) {
  customElements.define('comfort-bra-size-finder', ComfortBraSizeFinder);
}
